import React, { FC } from 'react'

import { ShieldAlert } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../../../ui/tooltip'
import { Button } from '../../../../../../ui/button'

import { getUserFullName } from '../../../../../../../helpers/helpers'

import { IUserInterface } from '../../../../../../../models/users/user.interface'

interface PendingRequestProps {
  user: IUserInterface | null
  size?: 'sm' | 'lg'
}

export const PendingRequest: FC<PendingRequestProps> = ({ user, size }) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size={size || 'default'}
          variant="ghost"
          className="p-0 opacity-50 hover:opacity-100 transition-all"
        >
          <ShieldAlert className="text-orange-600" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        The request was sent {user ? `to ${getUserFullName(user)}` : ''} and is pending.
      </TooltipContent>
    </Tooltip>
  )
}
